import { render, staticRenderFns } from "./CompanyGeneralInfo.vue?vue&type=template&id=9528ae8e&scoped=true"
import script from "./CompanyGeneralInfo.vue?vue&type=script&lang=js"
export * from "./CompanyGeneralInfo.vue?vue&type=script&lang=js"
import style0 from "./CompanyGeneralInfo.vue?vue&type=style&index=0&id=9528ae8e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9528ae8e",
  null
  
)

export default component.exports